import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import { Component, default as React } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import { Worker } from '../components'

class SingleWorker extends Component {
    constructor(props) {
        super(props)
        let { worker } = this.props.match.params

        this.state = {
            worker,
        }
    }

    componentDidUpdate() {}

    componentDidMount() {}

    render() {
        let { worker } = this.state
        // console.log('Loading worker', worker)
        return (
            <View column fullw fullh>
                <Worker forcedOpen={true} showDetails={true} workerId={worker} type="full" />
            </View>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(SingleWorker)))